import { type Place } from 'schema-dts'

export const getPlaceSchema = ({
  city,
  state,
}: {
  city: string | undefined
  state: string | undefined
}): Place | undefined => {
  if (city && state) {
    return {
      '@type': 'Place',
      name: `${city}, ${state}`,
      address: {
        '@type': 'PostalAddress',
        addressLocality: city,
        addressRegion: state,
      },
    }
  }
}
